import { USE_PRODUCTS_SERVICE, USE_PRODUCT_DATA_CACHING, fetchGraphql } from '@ori/fetching';

import { mapAllowedFavoriteProductCodes } from './mapAllowedFavoriteProductCodes';
import type { GetFavoriteProducts } from './types';
import type {
  GetProductPermissionsQuery,
  GetProductPermissionsQueryVariables,
} from '../models/graphql-types/operations';
import { productPermissionsQuery } from '../queries';

export const getProductPermissions = async ({
  currentLanguage,
  graphqlUrl,
  productCodes,
  sourceAppName,
  tenant,
  token,
  customerId,
}: GetFavoriteProducts): Promise<string[]> => {
  const { products } = await fetchGraphql<
    GetProductPermissionsQuery,
    GetProductPermissionsQueryVariables
  >({
    query: productPermissionsQuery,
    sourceAppName,
    url: graphqlUrl,
    customerId,
    headers: {
      [USE_PRODUCTS_SERVICE]: true,
      [USE_PRODUCT_DATA_CACHING]: true,
    },
    language: currentLanguage,
    tenant,
    token,
    variables: {
      productCodes,
    },
  });

  return mapAllowedFavoriteProductCodes(products);
};
